export default __webpack_public_path__ + "static/media/UGCNETTonic.dbad4f2da081c7b8dcf93fe128f6d783.webp";